<section class="contenido">
  <div class="row m-0 header justify-content-center">
    <h1 class="title">¿Quiénes Somos?</h1>
  </div>
  <div class="row mt-3 mt-md-5 mx-3 mx-md-0">
    <div class="col-md-2 col-0"></div>
    <div class="col-12 col-md-8 justify-content-center">
      <h2 class="mb-0">Conoce más sobre nuestro colegio</h2>
      <h1 class="text-uppercase mb-0">
        Somos un gremio de profesionistas de alta especialidad.
      </h1>
      <div class="row mt-4">
        <div class="col-12 col-lg-6 summary">
          <p class="text-jusitfy">
            <strong>SOMOS</strong> un gremio de Profesionistas con alta
            Especialidad Científica en el Tratamiento del Territorio y la
            Relación entre el ser Humano y su entorno. Garantizando el
            Equilibrio en el crecimiento de las Ciudades y en el Desarrollo
            Urbano Ordenado, Competitivo y Eficaz. <strong>SOMOS</strong> un
            órgano de consulta para el poder público en el sector de la
            arquitectura, urbanismo y el ordenamiento territorial con capacidad
            para promover lo conducente en la moralización de la misma.
            <strong>SOMOS</strong> una asociación de profesionistas que agrupa a
            los profesionales de la arquitectura en tabasco, y los representa
            ante las autoridades y la sociedad a la cual sirve promoviendo la
            ética, el servicio social y el correcto ejercicio de la profesión.
            <strong>SOMOS</strong> un espacio de encuentro de los arquitectos,
            incluyente, que fomenta y promueve el desarrollo de la arquitectura,
            de la calidad de vida de sus colegiados y de la comunidad.
          </p>
        </div>
        <div class="col-12 col-lg-6 side-img">
          <img src="../../../assets/img/cat_convenios.jpg" alt="Nosotros" />
        </div>
      </div>
    </div>
    <div class="col-md-2 col-0"></div>
  </div>
  <div class="row mt-3 mt-md-5 mx-3 mx-md-0">
    <div class="col-md-2 col-0"></div>
    <div class="col-12 col-md-8 justify-content-center nosotros">
      <h2 class="mb-0 mt-4">Historia</h2>
      <h1 class="mb-0">Antecedentes del Colegio</h1>
      <small class="text-muted text-uppercase mt-0"
        >El pasado, cimientos de nuestro presente</small
      >

      <div class="row mt-4">
        <div class="col-12 col-md-4 summary">
          <p class="text-justify">
            El Colegio de Arquitectos tal como lo conocemos hoy es el resultado
            de un largo pero satisfactorio proceso de gestación, no libre de
            altos y bajos en una historia de prueba y error. En los años 60’s
            surge el Colegio de Arquitectos Residentes en el Estado de Tabasco
            (CARET) El cual estaba integrado por: Zapata Tosca, Marín, Pastrana,
            Domínguez e Izundegui; todos ellos, en su mayoría dedicados a la
            obra oficial del gobierno del Estado. Es entonces cuando surge la
            Oficina de Obras Públicas Municipales con la finalidad de dar a
            conocer la profesión y pugnar por los intereses comunes; a ellos se
            les debe la idea de la conformación de un colegio local. Más
            adelante, debido al bajo número de arquitectos, se ven forzados a
            unirse a los ingenieros de la localidad, creando la Sociedad de
            Ingenieros y Arquitectos de Tabasco, conformado por: Ing. Agron.
            Humberto Muñoz, Ing. Agron. Enrique Muñoz, Arq. Eduardo Castilla,
            Arq. Carlos A. Izundegui, Ing. Jorge Conde, Arq. Alberto del Rivero,
            Ing. Jorge Orrico y algunos Ingenieros-Mecánico-Electricistas de la
            C.F.E., teniendo como sede los jardines del Hotel Hilda.
          </p>
        </div>
        <div class="col-12 col-md-4 summary">
          <p class="text-justify">
            La diversidad de miembros al interior de esta agrupación no
            fructifica debido a las discrepancias propias de las profesiones
            afines, pero a la vez diversas, y a los 6 meses desaparece. Comienza
            un nuevo sexenio y entonces al CARET ya no lo representa el Dir. de
            Obras Públicas del Estado, sino que con el consentimiento del Sr.
            Manuel Mora (entonces gobernador) queda a cargo el Arq. Revueltas,
            quién llega con Luna, Villafaña y García Andalón; uniéndoseles De
            Lille, García Olivera y Membreño. El 21 de febrero de 1968, según
            acta de la Notaría Pública #11 a cargo del Lic. Roque Camelo V., se
            registran con el nombre de Colegio de Arquitectos Tabasqueños A.C.
            Con los siguientes integrantes: Luis Alonso Prats G., Carlos A.
            Izundegui R., Servando Aréchiga V., Ventura Marín A., Víctor M.
            Pastrana M., Mario de Lille F., Norberto B. Barahona A., F. Ariosto
            Fonz C., Fermín A. Revueltas P., Felipe Luna V., J. Miguel Bosch L.
            de Ll., Edberto Membreño J., y los pasantes: Juan A. Medina P.,
            Jacinto Zapata Ll., J. de Jesús García A. y Guillermo Villafaña.
            Pero esta asociación no cuenta con suficiente apoyo por lo que se
            disuelve antes de terminar la elaboración de los estatutos.
          </p>
        </div>
        <div class="col-12 col-md-4 summary">
          <p class="text-justify">
            El nuevo gobierno del Lic. Mario Trujillo García proclama la Ley de
            Profesiones y encarga al Sr. Ramón Magaña Romero, Presidente
            Municipal del Centro, la conformación del Colegio contando con Mario
            de Lille a la cabeza. Fundándose así el 14 de octubre de 1974 el
            Colegio que conocemos actualmente y siendo los fundadores de este
            los siguientes arquitectos: Rubén Susunaga López, Edberto Membreño
            Juárez, Juan A. Medina Palomera, Mario de Lille Fuentes, Fermín A.
            Revueltas Peralta, José R. Gómez Flores, César E. Zurita Campos,
            Felipe Luna Valencia, Manuel Suarez Herrera, F. Ariosto Fonz
            Cabrera, Armando Rodríguez Badillo, Víctor M. Pastrana Mondragón,
            José M. García Olivera, Ventura Marín Azcuaga, Carlos A. Izundegui
            Rullán, Andrés Pérez Flores, Alberto Muñoz Camacho, Claudio César
            Santos Muñoz. Las reuniones de esta nueva asociación tendrían su
            sede en el despacho y Sala de Cabildos del anterior edificio del
            Ayuntamiento, ubicado frente al Parque Juárez, hasta la construcción
            del actual Colegio en el año de 1985 bajo el cargo del Arq. Andalón,
            pocos años después el Colegio cambia su nombre por el de Colegio de
            Arquitectos Tabasqueños A.C., a partir del 14 de mayo de 1990.
          </p>
        </div>
      </div>
    </div>
    <div class="col-md-2 col-0"></div>
  </div>
  <div class="row mt-3 mt-md-5 mx-3 mx-md-0 mb-5">
    <div class="col-md-2 col-0"></div>
    <div class="col-12 col-md-8 justify-content-center nosotros">
      <h1 class="mb-0 mt-4">Objetivos</h1>
      <small class="text-muted text-uppercase mt-0">Frase</small>
      <div class="row mt-4">
        <div class="col-12 col-md-6 summary">
          <h3>
            <strong
              >1. Promover una mayor presencia del Arquitecto ante la autoridad,
              la academia y la sociedad.</strong
            >
          </h3>
          <ul class="objetivos ml-md-2 ml-0">
            <li class="bullet-points">
              <p>
                Fomentar canales de comunicación ante las diversas instancias,
                donde el quehacer del Arquitecto tiene trascendencia.
              </p>
            </li>
            <li class="bullet-points">
              <p>
                Fomentar el trabajo del Arquitecto hacia la comunidad, y las
                áreas de gobierno relacionadas con la planeación y la
                construcción.
              </p>
            </li>
            <li class="bullet-points">
              <p>
                Vincular al Colegio con los centros educativos de formación
                profesional.
              </p>
            </li>
            <li class="bullet-points">
              <p>
                Consolidar el quehacer arquitectónico como referente del sector
                de la industria de la Construcción y el Desarrollo Urbano.
              </p>
            </li>
          </ul>
        </div>
        <div class="col-12 col-md-6 summary">
          <h3>
            <strong
              >2. Lograr que el Colegio se convierta en un espacio de encuentro,
              superación profesional, y desarrollo humano integral.</strong
            >
          </h3>
          <ul class="objetivos ml-md-2 ml-0">
            <li class="bullet-points">
              <p>
                Incentivar la participación en la vida del Colegio mediante la
                elaboración de propuestas orientadas a mejorar la calidad del
                ejercicio profesional.
              </p>
            </li>
            <li class="bullet-points">
              <p>
                Constituirse como el espacio idóneo para la defensa de los
                intereses tanto individuales como colectivos de sus miembros,
                respetando los principios éticos y legales que nos rigen.
              </p>
            </li>
            <li class="bullet-points">
              <p>
                Promover la solidaridad y compañerismo de los Arquitectos en las
                esferas profesional, social y familiar.
              </p>
            </li>
            <li class="bullet-points">
              <p>
                Procurar los recursos necesarios para la realización de sus
                funciones gremiales y sociales.
              </p>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="col-md-2 col-0"></div>
  </div>
</section>
